import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button, Checkbox } from '@mui/material';
import language from '../../languages/languages';
import VerifiedIcon from '@mui/icons-material/Verified';



export default function BasicTable(props) {
  const [rows, setRows] = React.useState([])
  const [validated, setValidated] = React.useState("")
  const [validatedInList, setValidatedInList] =React.useState(true)


  React.useEffect(() => {
    var birdList = props.birds
    let rows2 = []
    setRows(rows2)
    for (let i = 0; i < birdList.length && i < 3; i++) {
      rows2.push({ name: birdList[i].latinName, prop: (birdList[i].score * 100).toFixed(2), germanName: birdList[i].germanName })
      setRows(rows2)
    }

  }, [props.birds])

  React.useEffect(() => {

    if (props.validation) {
      let max = { "amount": 0 }
      for (let key in props.validation["summary"]) {
        if (props.validation["summary"][key]["amount"] > max["amount"]) {
          max = props.validation["summary"][key]
        }
      }
      setValidated(max)
      var birdList = props.birds
      let inList = false
      for (let i = 0; i < birdList.length && i < 3; i++) {
        if(max.latinName == birdList[i].latinName){
          inList = true
        }
      }
      setValidatedInList(inList)
    }

  }, [props.validation])


  return (
    <div>
      {rows.length == 0 && props.finished == "pending" ? < div><p> {language[props.language]["stations"]["wait1"]} {language[props.language]["stations"]["wait2"]} </p> <Button variant="contained" onClick={() => { props.getStation() }} style={{ float: "right", margin: "15px" }}>Refresh</Button></div>
        :
        rows.length == 0 ? <p> {language[props.language]["table"]["noBird"]} </p> :
          <TableContainer component={Paper}>
            <Table aria-label="simple table" style={{ maxWidth: "100%", "table-layout": 'fixed' }} >
              <TableHead>
                <TableRow>
                  <TableCell>{language[props.language]["table"]["species"]}</TableCell>
                  <TableCell>{language[props.language]["table"]["name"]}</TableCell>
                  <TableCell align="right">{language[props.language]["table"]["propability"]}</TableCell>
                  <TableCell>{language[props.language]["table"]["validation"]}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.latinName}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      <span style={{display: "flex"}}>{row.name} {row.name == validated.latinName ? <VerifiedIcon color="success" />: ""} </span>
                    </TableCell>
                    {row.germanName == "" ? <TableCell>  </TableCell> : <TableCell><a href={"https://www.nabu.de/tiere-und-pflanzen/voegel/portraets/" + row.germanName} target="_blank">{row.germanName} </a> </TableCell>}
                    <TableCell align="right">{row.prop}</TableCell>
                    <TableCell padding="checkbox">
                      <Checkbox checked={row.name === props.bird} onChange={() => props.setBird(row.name)} />
                    </TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          }
    {
      !validatedInList ? <span>Validierter Vogel: {validated.germanName && validated.germanName!= ""? validated.germanName : validated.latinName}</span> : ""
    }
    </div>
  );
}